import { createGetAllAPI, createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const EVAL_FAILED_MAPPINGS_URL = `${BASE_URL}/students/eval-failed-mappings`;

// getAll passes the query as getURL's first argument.
const { useGetAll: useGetAllEvalFailedMappings } = createGetAllAPI({
  getURL: query => `${EVAL_FAILED_MAPPINGS_URL}/?${stringify(query || {})}`,
});

// requested_slots repeats per slot, which stringify only emits with arrayFormat none.
const candidatesQuery = ({ teacherId, tier, requested_slots: slots } = {}) =>
  stringify(
    {
      ...(teacherId ? { teacher_id: teacherId } : {}),
      ...(tier ? { tier } : {}),
      ...(slots && slots.length ? { requested_slots: slots } : {}),
    },
    { arrayFormat: 'none' },
  );

const { useGet: useGetEvalCoachCandidates } = createGetAPI({
  getURL: (intelEnrollmentId, query = {}) => {
    const params = candidatesQuery(query);

    return `${EVAL_FAILED_MAPPINGS_URL}/${intelEnrollmentId}/candidates/${
      params ? `?${params}` : ''
    }`;
  },
});

const { useGet: useGetEvalCoachEligibility } = createGetAPI({
  getURL: (intelEnrollmentId, query = {}) =>
    `${EVAL_FAILED_MAPPINGS_URL}/${intelEnrollmentId}/candidates/?${candidatesQuery(
      query,
    )}`,
});

const { usePost: usePostEvalManualCoachAssign } = createPostAPI({
  getURL: (_, intelEnrollmentId) =>
    `${EVAL_FAILED_MAPPINGS_URL}/${intelEnrollmentId}/assign/`,
});

export {
  useGetAllEvalFailedMappings,
  useGetEvalCoachCandidates,
  useGetEvalCoachEligibility,
  usePostEvalManualCoachAssign,
};
